import mainImg from './mainImage.png';
import { BlockPage } from '../../../routings/pages/BlockPage/BlockPage';
import { Icons } from '@silverfort/sf-components';

export const CloudNHIBlockPage = () => {
    const topics = [
        <span>
            Detect over <span className="font-medium">48 types</span> of different cloud NHIs
        </span>,
        <span>Gain insight into effective NHI privileges and activity patterns</span>,
        <span>Uncover ownership to enable lifecycle management</span>,
        <span>Expose dormancy, unrotated credentials, partially offboarded identities, and much more</span>
    ];

    return (
        <BlockPage
            leftContent={{
                title: 'Cloud Non-Human Identities',
                image: mainImg
            }}
            rightContent={{
                accessLink: 'https://www.silverfort.com/cloud-nhi-signup/?utm_source=PQL&utm_content=main',
                description: (
                    <span>
                        Discover <span className="font-medium">NHIs</span> such as{' '}
                        <span className="font-medium">Service Accounts, Access Keys, Tokens, Certificates,</span> and
                        more across <span className="font-medium">cloud IdPs, cloud infrastructure</span> providers, and
                        SaaS applications.
                    </span>
                ),
                icon: Icons.ServiceAccountRobot,
                title: 'Secure your Cloud NHIs with Silverfort',
                topics: topics
            }}
        />
    );
};
